import React, { useEffect, useState } from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';
import { keyframes } from '@mui/system';

// Simplified animations
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const float = keyframes`
  50% { transform: translateY(-20px); }
`;

export const Home: React.FC = () => {
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
    const [isHovering, setIsHovering] = useState(false);

    useEffect(() => {
        const handleMouseMove = (e: MouseEvent) => {
            setMousePos({ x: e.clientX, y: e.clientY });
        };

        window.addEventListener('mousemove', handleMouseMove);
        return () => window.removeEventListener('mousemove', handleMouseMove);
    }, []);

    return (
        <>
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: -1,
                    backgroundImage: 'url("/images/background.jpeg")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    opacity: 1,
                }}
            />
            <div
                className={`custom-cursor ${isHovering ? 'hover' : ''}`}
                style={{ left: `${mousePos.x}px`, top: `${mousePos.y}px` }}
            />
            <Container>
                <Box
                    sx={{
                        width: '100%',
                        maxWidth: '1400px',
                        margin: '0 auto',
                        animation: `${fadeIn} 1s ease-out`,
                        zIndex: 1,
                    }}
                    onMouseEnter={() => setIsHovering(true)}
                    onMouseLeave={() => setIsHovering(false)}
                >
                    <Typography
                        variant="h1"
                        sx={{
                            fontSize: { xs: '3rem', sm: '4rem', md: '5.5rem' },
                            fontWeight: 900,
                            mb: 3,
                            // background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                            // background: 'linear-gradient(45deg, #FF4081 30%, #FFA000 90%)', // Pink to amber
                            // background: 'linear-gradient(45deg, #FF6B6B 30%, #FF9A8B 90%)', // Coral to peach
                            // background: 'linear-gradient(45deg, #FF4081 30%, #FF79B0 90%)', // Hot pink gradient

                            // WARM ORANGES & REDS
                            // background: 'linear-gradient(45deg, #FF4500 30%, #FFA07A 90%)',  // Burnt orange to light salmon
                            // background: 'linear-gradient(45deg, #FF6B6B 30%, #FFB88C 90%)',  // Coral to peach
                            // background: 'linear-gradient(45deg, #FF3E00 30%, #FFBE0B 90%)',  // Deep orange to golden

                            // PINKS & PURPLES
                            // background: 'linear-gradient(45deg, #FF1493 30%, #FF69B4 90%)',  // Deep pink to hot pink
                            // background: 'linear-gradient(45deg, #FF0066 30%, #FF99CC 90%)',  // Bright pink to pastel pink
                            // background: 'linear-gradient(45deg, #B721FF 30%, #FF99CC 90%)',  // Purple to pink

                            // VIBRANT COMBINATIONS
                            // background: 'linear-gradient(45deg, #FF0099 30%, #FFD700 90%)',  // Magenta to gold
                            // background: 'linear-gradient(45deg, #FF416C 30%, #FF4B2B 90%)',  // Pink to orange-red
                            // background: 'linear-gradient(45deg, #FF8C00 30%, #FFA500 90%)',  // Dark orange to orange

                            // NEON VIBES
                            // background: 'linear-gradient(45deg, #FF2975 30%, #FF9F4A 90%)',  // Neon pink to neon orange
                            // background: 'linear-gradient(45deg, #FF00FF 30%, #FF69B4 90%)',  // Magenta to hot pink
                            // background: 'linear-gradient(45deg, #FF1E1E 30%, #FF9A00 90%)',  // Bright red to amber

                            // SUNSET TONES
                            background: 'linear-gradient(45deg, #FF512F 30%, #FF9472 90%)',  // Sunset orange
                            // background: 'linear-gradient(45deg, #FF6B6B 30%, #FFE66D 90%)',  // Coral to yellow
                            // background: 'linear-gradient(45deg, #FF7E5F 30%, #FEB47B 90%)',  // Terracotta to peach

                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            transition: 'transform 0.3s ease',
                            '&:hover': {
                                transform: 'scale(1.02)',
                            },
                        }}
                    >
                        If it's fast, loud, and flies, I'm into it.
                    </Typography>

                    <Typography
                        variant="h2"
                        sx={{
                            fontSize: { xs: '2rem', md: '3rem' },
                            fontWeight: 700,
                            color: 'white',
                            mb: 3,
                            opacity: 0.9,
                            animationDelay: '0.2s',
                            transition: 'transform 0.3s ease',
                            '&:hover': {
                                transform: 'translateX(10px)',
                            },
                        }}
                    >
                        Hi, I'm Sebastian
                    </Typography>

                    <Typography
                        variant="h4"
                        component="p"
                        sx={{
                            fontSize: { xs: '1.5rem', md: '2rem' },
                            color: 'white',
                            fontWeight: 300,
                            opacity: 0.8,
                            animationDelay: '0.4s',
                            position: 'relative',
                            '&::after': {
                                content: '""',
                                position: 'absolute',
                                bottom: '-10px',
                                left: 0,
                                width: '0',
                                height: '2px',
                                background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                                transition: 'width 0.3s ease',
                            },
                            '&:hover::after': {
                                width: '100%',
                            },
                        }}
                    >
                        and you have touched down on my portfolio page.
                    </Typography>
                </Box>
            </Container>
        </>
    );
}
